import NavigateNextIcon from "@mui/icons-material/NavigateNext"
import { CardActions } from "@mui/material"
import { ReactElement } from "react"

import { TT_GO_TO_DEVICE_SUMMARY } from "../../../constants/tooltips"
import AppButton from "../../buttons/appButton"
import VerticalKeyValueList from "../../dataDisplay/verticalKeyValueList"
import AppTooltip from "../../helper/appTooltip"
import LctAvatar from "../../pills/lct/lctAvatar"
import { LCT_METADATA_DISPATCHER } from "../../pills/lct/lctMetadataDispatcher"
import { AppCard, AppCardHeader, AppCardContent } from "../../surfaces/appCard"

interface IExistingDeviceCardProps {
    deviceReference: string
    deviceType: string
    details: Record<string, string | number>
    index: number
    onClick?: () => void
}

/**
 * Card for displaying details about an existing device on a property. Designed
 * for use on the single application summary page. This component has been
 * designed to be schema version agnostic. It assumes device is of type
 * `ExistingDevice[]`. This type has a number of recognised fields and
 * a number of unrecognised fields. The latter are contained in the `details`
 * prop, and are mapped out in a way in which this code does not need to know
 * the specific contents. Other props are explicity typed in `ExistingDevice[]`
 * and hence can be safely broken into their own props.
 */
const ExistingDeviceCard = ({
    deviceReference,
    deviceType,
    details,
    index,
    onClick,
}: IExistingDeviceCardProps): ReactElement => (
    <AppCard>
        <AppCardHeader
            title={deviceReference}
            subheader={LCT_METADATA_DISPATCHER[deviceType]?.label}
            avatar={<LctAvatar lcts={[deviceType]} />}
        />
        <AppCardContent>
            <VerticalKeyValueList kwargs={details} />
        </AppCardContent>
        {onClick && (
            <CardActions sx={{ justifyContent: "flex-end" }}>
                <AppTooltip title={TT_GO_TO_DEVICE_SUMMARY}>
                    <AppButton
                        variant="outlined"
                        onClick={onClick}
                        endIcon={<NavigateNextIcon />}
                    >
                        View Device Details
                    </AppButton>
                </AppTooltip>
            </CardActions>
        )}
    </AppCard>
)
ExistingDeviceCard.defaultProps = {
    onClick: null,
}

export default ExistingDeviceCard
